"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _scala = _interopRequireDefault(require("refractor/lang/scala.js"));

;
var _default = _scala["default"];
exports["default"] = _default;